import { render, staticRenderFns } from "./AttributeDetails.vue?vue&type=template&id=7c8d553c&scoped=true"
import script from "./AttributeDetails.vue?vue&type=script&lang=ts"
export * from "./AttributeDetails.vue?vue&type=script&lang=ts"
import style0 from "./AttributeDetails.vue?vue&type=style&index=0&id=7c8d553c&lang=scss"
import style1 from "./AttributeDetails.vue?vue&type=style&index=1&id=7c8d553c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d553c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c8d553c')) {
      api.createRecord('7c8d553c', component.options)
    } else {
      api.reload('7c8d553c', component.options)
    }
    module.hot.accept("./AttributeDetails.vue?vue&type=template&id=7c8d553c&scoped=true", function () {
      api.rerender('7c8d553c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/attribute/components/AttributeDetails.vue"
export default component.exports